import { EditorState, Plugin } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'
import { Schema, DOMParser } from 'prosemirror-model'
import { addListNodes } from 'prosemirror-schema-list'
import { schema as baseSchema } from 'prosemirror-schema-basic'
import { interpolationPlaceholderNodeSpec } from './interpolationPlaceholder'
import { exampleSetup } from '../example'
import '../example/style.css'

export const schema = new Schema({
  // nodes: baseSchema.spec.nodes.addToEnd('interpolationPlaceholder', interpolationPlaceholderNodeSpec),
  nodes: addListNodes(baseSchema.spec.nodes.addToEnd('interpolationPlaceholder', interpolationPlaceholderNodeSpec), 'paragraph block*', 'block'),
  marks: baseSchema.spec.marks,
})

export function createEditor(original, context) {
  let state = EditorState.create({
    doc: DOMParser.fromSchema(schema).parse(original),
    schema,
    plugins: [
      // history(),
      // prosemirrorKeymap.keymap(buildKeymap(options.schema, options.mapKeys)),
      // keymap({ 'Mod-z': undo, 'Mod-shift-z': redo }),
      // keymap(baseKeymap),
      new Plugin({
        view() {
          return {
            update() {
              context.stateUpdateDetector = !context.stateUpdateDetector
            },
          }
        },
      }),
      new Plugin({
        props: {
          attributes: {
            class: 'km-editor__original',
          },
        },
      }),
      ...exampleSetup({
        schema,
        menuBar: false,
      }),
    ],
  })

  const view = new EditorView(original, {
    state,
    // dispatchTransaction(transaction) {
    //   console.log('Document size went from', transaction.before.content.size, 'to', transaction.doc.content.size)
    //   let newState = view.state.apply(transaction)
    //   view.updateState(newState)
    // },
  })

  return view
}
